import React from "react";
import "./../Styles/Policy.css";

export default function Terms() {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Terms & Conditions</h1>
          <p className="website">www.embroiderybazar.in</p>
          <p className="last-update">
            Last Updated: <strong>July 18, 2026</strong>
          </p>
        </div>

        <section className="policy-section">
          <h2>Welcome</h2>

          <p>
            Welcome to <strong>www.embroiderybazar.in</strong>. This website is
            owned and operated by <strong>Life Time Creation</strong>. By
            accessing or using this website, purchasing digital embroidery
            designs, or utilizing our services, you agree to be bound by the
            following Terms & Conditions.
          </p>
        </section>

        <section className="policy-section">
          <h2>1. Eligibility & Account Registration</h2>

          <div className="policy-card">
            <ul>
              <li>
                To purchase products or services from this website, you may be
                required to create a user account.
              </li>

              <li>
                You are responsible for maintaining the confidentiality of your
                account credentials.
              </li>

              <li>
                You are responsible for all activities carried out through your
                account.
              </li>
            </ul>
          </div>
        </section>

        <section className="policy-section">
          <h2>2. Intellectual Property Rights & Usage License</h2>

          <div className="policy-card">
            <ul>
              <li>
                All digital embroidery designs, vectors, patterns, and software
                layouts available on this website are the exclusive intellectual
                property of <strong>www.embroiderybazar.in</strong>.
              </li>

              <li>
                Purchasing a design grants a{" "}
                <strong>
                  non-exclusive, non-transferable, single-user license
                </strong>{" "}
                to use the design on embroidery machines.
              </li>

              <li>
                <strong>Prohibited Use:</strong> You may not resell, share,
                copy, modify, sublicense, or upload any digital embroidery files
                (.DST, .EMB, .PES, etc.) to any other platform.
              </li>
            </ul>
          </div>
        </section>

        <section className="policy-section">
          <h2>3. Pricing & Payments</h2>

          <p>
            All prices displayed on the website are in Indian Rupees (INR). We
            use secure third-party payment gateways to process online payments
            safely and securely.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Cancellation & Refund Policy</h2>

          <div className="policy-card">
            <ul>
              <li>
                Due to the nature of downloadable digital embroidery files,
                <strong> all sales are final.</strong>
              </li>

              <li>
                Once a download link has been generated or the file has been
                delivered, refunds, cancellations, or exchanges cannot be
                provided.
              </li>
            </ul>
          </div>
        </section>

        <section className="policy-section">
          <h2>5. Limitation of Liability</h2>

          <p>
            Embroidery Bazar provides digital files and related services on an
            <strong> "as-is"</strong> basis. We are not responsible for any
            damage to embroidery machines, fabrics, materials, software, or
            computer systems caused by improper machine settings, software
            incompatibility, or file modifications performed by users.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Governing Law & Jurisdiction</h2>

          <p>
            These Terms & Conditions shall be governed by the laws of India. Any
            disputes arising from the use of this website shall be subject to
            the exclusive jurisdiction of the courts located in
            <strong> Surat, Gujarat, India.</strong>
          </p>
        </section>

        <section className="policy-section">
          <h2>Contact Information</h2>

          <div className="contact-box">
            <p>
              <strong>Email</strong>
            </p>

            <p>embroiderybazar05@gmail.com</p>

            <hr />

            <p>
              <strong>Phone</strong>
            </p>

            <p>+91 9909614445</p>

            <hr />

            <p>
              <strong>Office Address</strong>
            </p>

            <p>
              Shop No: 17/UGF, Ranuja Complex
              <br />
              Near Riddhi Siddhi School
              <br />
              Vallabhacharya Road
              <br />
              Ashvanikumar
              <br />
              Surat - 395008
              <br />
              Gujarat, India
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
